import style from "./block.module.scss";
import {
  BlockWrapper,
  defineBlock,
  smartProps,
  useChildrenBlocks,
  useEditor,
} from "@smartfire/js-block-engine";
import { InnerBlocks } from "@wordpress/block-editor";
import { ReactComponent as ArrowCircle } from "../assets/icons/arrow-circle.svg";
import clsx from "clsx";
import { useState } from "react";
import { EditableHeading, EditableText } from "@smartfire/components";

function Block() {
  const [slideSelected, setSlideSelected] = useState(0);
  const { children, Child } = useChildrenBlocks();
  const { isEditing } = useEditor();

  // Add touch state for swipe detection
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const handleButton = (type) => {
    if (children && children.length > 0) {
      if (type === "next" && slideSelected < children.length - 1) {
        setSlideSelected(slideSelected + 1);
      } else if (type === "prev" && slideSelected > 0) {
        setSlideSelected(slideSelected - 1);
      }
    }
  };

  const smallOrNotSmall = (index) => {
    switch (true) {
      case slideSelected === 0 && (index === 1 || index === 2):
        return true;
      case children &&
        slideSelected === children.length - 1 &&
        (index === children.length - 2 || index === children.length - 3):
        return true;
      case slideSelected === index - 1 || slideSelected === index + 1:
        return true;
      default:
        return false;
    }
  };

  // Handle touch events for swipe functionality
  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;

    if (distance > 50) {
      // Swiped left, show next slide
      handleButton("next");
    }

    if (distance < -50) {
      // Swiped right, show previous slide
      handleButton("prev");
    }

    // Reset touch positions
    setTouchStart(null);
    setTouchEnd(null);
  };

  return (
    <BlockWrapper.Div className={style.block}>
      <div className={style.controlsDiv}>
        <EditableHeading
          smartProp={"title"}
          placeholder={"Insérer un titre..."}
          className={style.title}
          allowedFormats={["core/text-color", "core/italic", "core/bold"]}
        />
        <EditableText
          smartProp={"content"}
          tagName={"p"}
          className={style.content}
        />
        <div className={style.controls}>
          <button
            className={clsx(slideSelected === 0 && style.gray)}
            onClick={() => handleButton("prev")}
          >
            <ArrowCircle />
          </button>
          <span>
            {slideSelected + 1} sur {children && children.length}
          </span>
          <button
            className={clsx(
              children && slideSelected === children.length - 1 && style.gray
            )}
            onClick={() => handleButton("next")}
          >
            <ArrowCircle />
          </button>
        </div>
      </div>
      <div
        className={clsx(style.slides, isEditing && style.isEditing)}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {isEditing ? (
          <InnerBlocks
            allowedBlocks={["smartfire/explore-slider---item"]}
            template={[
              ["smartfire/explore-slider---item"],
              ["smartfire/explore-slider---item"],
              ["smartfire/explore-slider---item"],
            ]}
          />
        ) : (
          children &&
          children.length > 0 &&
          children.map((__, i) => {
            return (
              <Child
                index={i}
                otherClass={clsx(
                  i,
                  slideSelected === i && style.slideSelected,
                  smallOrNotSmall(i) && style.smallSlide
                )}
                handleClick={() => {
                  setSlideSelected(i);
                }}
              />
            );
          })
        )}
      </div>
    </BlockWrapper.Div>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    title: smartProps.object.withDefault({
      content: "Explorez nos domaines",
      headingLevel: 2,
    }),
    content: smartProps.string.withDefault(
      "Lorem ipsum dolor sit amet consectetur. Arcu odio risus ut bibendum nisl.At convallis cras fringilla placerat bibendum."
    ),
  },
  setup: {
    title: "Explore Slider",
  },
});
